<template>
    <modal class="w-full h-full" :new_partners="true" @close="$emit('close')">
      <div class="py-8  text-main-text relative">
        <button class="absolute pin-t pin-r outline-none m-6 z-40" @click="$emit('close')">
          <img class="h-4" src="@/assets/SVG/cross-partners.svg"/>
        </button>
        <div class="flex flex-col text-center w-full justify-center relative items-center pb-4">
          <div class="px-6 mt-10">
            <p class="flex flex-col heading text-brand-light text-center w-full justify-center items-center text-sm font-semibold">
              Упс, мы не смогли обработать ваш файл</p>
            <div
                class="text-sm flex flex-col text-center w-full justify-center items-center pt-4">
              <p class="text-main-text font-normal" style="line-height: 25px">
                {{catch_file_text}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </modal>
</template>
<script>
import ModalMixin from '../../../../../mixins/modals';
import Modal from '@/views/modals/base-modal';


export default {
  name: 'StatsFileCatchModal',
  components: { Modal },
  props: ['catch_file_text'],

  mixins: [ModalMixin],
  data() {
    return {

    };
  },
};

</script>


<style scoped>
.confirm-button {
    width: 200px;
}
</style>

